import { toDateInput } from 'helpers/date';

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const defaultState = {
  id: null,
  referenceNumber: null,
  invoiceDate: null,
  invoicePayedDate: null,
  vatId: null,
  visibility: null,
  memberAssociation: null,
  clientMemberAssociation: null,
  dateFrom: null,
  dateTo: null,
  invoicedCertificatesSelectedIds: [],
  uninvoicedCertificatesSelectedIds: [],
};

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
      memberAssociation: action.payload.memberAssociation?.id,
      clientMemberAssociation: action.payload.clientMemberAssociation?.id,
      invoiceDate: action.payload.invoiceDate ? toDateInput(action.payload.invoiceDate) : undefined,
      invoicePayedDate: action.payload.invoicePayedDate
        ? toDateInput(action.payload.invoicePayedDate)
        : undefined,
      dateFrom: action.payload.dateFrom ? toDateInput(action.payload.dateFrom) : undefined,
      dateTo: action.payload.dateTo ? toDateInput(action.payload.dateTo) : undefined,
    };
  }

  if (action.type === UPDATE_FIELD) {
    if (action.payload.name === 'resetSelectedIds') {
      return {
        ...state,
        invoicedCertificatesSelectedIds: action.payload.value,
        uninvoicedCertificatesSelectedIds: action.payload.value,
      };
    }
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
